export default "__VITE_ASSET__Dxya$JSs__"